var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"Nav",class:{
    Nav_position: _vm.pageIndex == 1,
    fixedShow: _vm.shouNav,
    fixedFalse: !_vm.shouNav,
    headWhite: _vm.headWhite,
  }},[_c('div',{staticClass:"Nav_language"},[_c('Language',{attrs:{"NavBar":_vm.NavBar,"pageIndex":_vm.pageIndex}}),_c('div',{staticClass:"hr_"}),_c('User',{attrs:{"NavBar":_vm.NavBar}})],1),_c('div',{staticClass:"Nav_conent"},[_c('Logo',{attrs:{"NavBar":_vm.NavBar,"pageIndex":_vm.pageIndex}}),_c('Menu',{staticClass:"Nav_box",attrs:{"NavBar":_vm.NavBar}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }